import { render, staticRenderFns } from "./SlideNavigationItem.vue?vue&type=template&id=16a759db&scoped=true&"
import script from "./SlideNavigationItem.vue?vue&type=script&lang=js&"
export * from "./SlideNavigationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a759db",
  null
  
)

export default component.exports